export enum SellOption {
    TicketAndVoucher = 'ticket_and_voucher',
    VoucherOnly = 'voucher_only',
    TicketOnly = 'ticket_only',
}
